module.exports = __webpack_public_path__ + "img/Toshi.8a4c2df3.jpg";